/* ============================================================================
   BYOB Cart Patch v2
   Integrates with KHP Cart Drawer for instant multi-item adds.
   Faster init — no excessive polling.
   ============================================================================ */

(function () {
  'use strict';

  function initBYOBCartPatch() {
    var forms = document.querySelectorAll('form[class*="bundle-form-"]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.setAttribute('data-khp-cart-skip', 'true');

      form.addEventListener(
        'submit',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var idInputs = form.querySelectorAll('input[name^="items["][name$="[id]"]');
          var qtyInputs = form.querySelectorAll('input[name^="items["][name$="[quantity]"]');

          if (idInputs.length === 0) {
            console.warn('[BYOB] No items to add.');
            return false;
          }

          var items = [];
          idInputs.forEach(function (idInput, i) {
            var qty = qtyInputs[i] ? parseInt(qtyInputs[i].value, 10) || 1 : 1;
            items.push({
              id: parseInt(idInput.value, 10),
              quantity: qty,
            });
          });

          var submitBtn = form.querySelector('button[type="submit"]');
          var originalLabel = '';
          if (submitBtn) {
            var label = submitBtn.querySelector('span');
            originalLabel = label ? label.textContent : '';
            if (label) label.textContent = 'Adding...';
            submitBtn.disabled = true;
          }

          function doAdd() {
            return window.KHPCart.addMultipleItems(items)
              .then(function () {
                if (window.KHPCart.showToast) {
                  window.KHPCart.showToast('✓ Bundle added to bag');
                }
                if (submitBtn) {
                  var lbl = submitBtn.querySelector('span');
                  if (lbl) lbl.textContent = originalLabel;
                  submitBtn.disabled = true;
                }
                var section = form.closest('[class*="bundle-"]');
                if (section) {
                  section.querySelectorAll('[class*="bundle-product-"].active').forEach(function (p) {
                    p.classList.remove('active');
                    var qty = p.querySelector('[class*="bundle-product-quantity-"]');
                    if (qty) qty.textContent = '1';
                  });
                }
              })
              .catch(function (err) {
                console.error('[BYOB] Add failed:', err);
                if (submitBtn) {
                  var lbl = submitBtn.querySelector('span');
                  if (lbl) lbl.textContent = originalLabel;
                  submitBtn.disabled = false;
                }
              });
          }

          // KHPCart should be loaded by now since both scripts are in theme.liquid
          if (window.KHPCart && window.KHPCart.addMultipleItems) {
            doAdd();
          } else {
            // Fallback: brief wait (max 2s, checked every 50ms = 40 tries)
            var attempts = 0;
            var waitForKHP = setInterval(function () {
              attempts++;
              if (window.KHPCart && window.KHPCart.addMultipleItems) {
                clearInterval(waitForKHP);
                doAdd();
              } else if (attempts >= 40) {
                clearInterval(waitForKHP);
                console.error('[BYOB] KHPCart never loaded');
                if (submitBtn) submitBtn.disabled = false;
              }
            }, 50);
          }

          return false;
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBYOBCartPatch);
  } else {
    initBYOBCartPatch();
  }
})();